<template>
  <div class="page-blueprint">
    <HeroHome :data="page" />

    <ComponentsLoader :components="page.components" />
  </div>
</template>

<script setup>
defineProps({
  page: { type: Object, required: true },
})
</script>
